import { Trans, useTranslation } from 'react-i18next';
import { Alert } from '@salecycle/ui-component-library';

interface IProps {
  error: any;
}

const email = 'support@salecycle.com';

export function UploadError({ error }: IProps) {
  const { t } = useTranslation('fileManagement');
  const isResponseError = !!error.response;

  const title = t('upload.error.heading');
  let message;
  if (isResponseError) {
    const statusMap = {
      0: t('upload.error.generic', { message: error.response.message }),
      403: t('upload.error.authorisation'),
    };

    message = statusMap[error.response?.status ?? 0] ?? statusMap[0];
  }

  return (
    <Alert variation={isResponseError ? 'warning' : 'error'} heading={title}>
      {isResponseError && message}
      {!isResponseError && (
        <>
          <Trans t={t} i18nKey="upload.error.noResponse">
            Unfortuately we are unable to upload your files at this stage.
            <br />
            Please contact <a href={`mailto:${email}`}>{{ email }}</a> for further information.
          </Trans>
        </>
      )}
    </Alert>
  );
}
